import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Setting that the low order minimum threshold for each currency supported by Faire.
 * https://www.notion.so/Highlight-Low-minimums-c3d3f1b148f94fe6b2589ed9fa902247
 */
export const LOW_ORDER_MINIMUM_THRESHOLD =
  'LOW_ORDER_MINIMUM_THRESHOLD' as SettingConst<
    'LOW_ORDER_MINIMUM_THRESHOLD',
    IFaireMoney,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'VISITOR_WEB'
  >;
